import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import { FaWhatsapp } from "react-icons/fa";
import aerocityphaseII from "../images/12th Oct Aerocity2_MasterPlan__page-0001.jpg"
function Aerocityphase2() {
  
  const message = "Hello, I am interested Unicorn Aerocity Phase II Plot";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${7550967009}?text=${encodedMessage}`;
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
           <ScrollToTop smooth top="100" color="maroon" />
          <div className='aerocitykolkata'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Unicorn Aerocity Phase II – Now Launched! <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        <div className="album py-2">
        <div className="container">
              <div className="row">
            <div className="col-md-6 mt-3">
            <img src={aerocityphaseII} className="card-img-top" alt="aerocityphaseII" />
                
                </div>
                <div className="col-md-6 mt-3">
                <h4><b>Unicorn Aerocity Phase II – Now Launched!</b></h4>
                <h6><b>✨ Premium Corner Plots Available</b></h6>
                <h6><b>📍 South-East Facing</b></h6>
                <h6><b>📐 Plot Sizes: 1,200 Sq. Ft. & 2,000 Sq. Ft.</b></h6>
                <p>Limited corner plots available.</p>
                <p className='mb-3'><b>Book your preferred plot today!</b></p>
                
      <div style={{ color: "white", padding: "12px;", margin: 8 }} className="fixed-bottom">                                <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
        <button style={{ padding: "8px 11px", backgroundColor: "#1B8755", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
          <FaWhatsapp style={{ marginRight: "3px" }} /> Chat on WhatsApp
        </button>
      </a>  
      </div>
                </div>
            </div>
            </div>
        </div>
        <br/>
    </div>
  )
}

export default Aerocityphase2